<template>
<span>404</span>
</template>
<script setup >

</script>
<style scoped lang='scss'>

</style>